<mat-sidenav-container>
  <mat-sidenav #sidenav [mode]="'over'">
    <app-sidenav-content></app-sidenav-content>
  </mat-sidenav>

  <mat-sidenav-content>
    <app-header
    
    (openSideNav)="sidenav.toggle()"
  ></app-header>
  <!-- (isHandsetPortrait)="isHandsetPortraitStatus($event)" -->
    
    <!-- <div>
      <div class="dictionary-heading">{{ "Word Not Found" | translate }}</div>
    </div> -->

    <div class="sggs-dashboard-content">
      <div class="small-carousel carousel-wrapper">
        <div class="title-banner-wrapper" [class.is-mobile]="isHandsetPortrait" >
          <h1 class="bani-title">  
            <span class="main-title"> </span>
           
            <!-- <p class="subtitle">{{ sectionName }} </p> -->
            <!-- {{ "Bani Details" | translate }} --> 
          </h1>
        </div>
      </div>
      <div class="breadcrumbs-tools-wrapper" [class.is-mobile]="isHandsetPortrait">
        <div class="breadcrumbs-wrapper">
          
          <!-- <span class="breadcrumb-to-icon">
            <mat-icon>keyboard_arrow_right</mat-icon>
          </span>
          <span [matMenuTriggerFor]="sectionMenu" class="cursor-pointer 2">
           
          </span> -->
          <!-- <mat-icon [matMenuTriggerFor]="sectionMenu">arrow_drop_down</mat-icon>
          <mat-menu yPosition="below" #sectionMenu="matMenu"> -->
            <!-- <ng-container >
              
                          
            </ng-container>
          </mat-menu> -->

          <!-- Subsection Menu <ng-container *ngIf="currentSectionSequence !== 0"> -->
          
          <ng-container>
            <!-- <span class="breadcrumb-to-icon">
              <mat-icon>keyboard_arrow_right</mat-icon>
            </span>

            <span [matMenuTriggerFor]="subSectionMenu" class="cursor-pointer 3">
             
            </span>
            <mat-icon [matMenuTriggerFor]="subSectionMenu"
              >arrow_drop_down</mat-icon
            > -->
            <mat-menu yPosition="below" #subSectionMenu="matMenu">
              <ng-container
                >
                <button mat-menu-item>
                </button>
              </ng-container>
            </mat-menu>
          </ng-container>
        </div>
        <div class="formatting-options-wrapper">
          <span [matMenuTriggerFor]="fontMenu"> {{ "Text_Size" | translate }} </span>
          <!-- <mat-icon (click)="showFontList()"> format_size</mat-icon>
 -->      
          <div class="font-wrapper">
            <mat-icon class="fnt-icon" [matMenuTriggerFor]="fontMenu"><img src="/assets/images/font.png"> </mat-icon>
            <mat-menu class="fnt-menu" xPosition="before" #fontMenu="matMenu">
              <ul id="fontSize" class="fnt-menu-list" [class.is-mobile]="isHandsetPortrait">
                <li style="font-size: 16px">16</li>
                <li style="font-size: 18px">18</li>
                <li style="font-size: 20px">20</li>
                <li style="font-size: 22px">22</li>
                <li style="font-size: 24px">24</li>
              </ul>
            </mat-menu>
            <span class="seprator">|</span>
          </div>
          <span [matMenuTriggerFor]="shareMenu"> {{ "Share" | translate }} </span>
          <div class="social-share" [class.is-mobile]="isHandsetPortrait">
            <mat-icon class="share-icon" [matMenuTriggerFor]="shareMenu"><img src="/assets/images/share.png"> </mat-icon>
            <mat-menu class="share-menu"  xPosition="before" #shareMenu="matMenu">
              <share-buttons theme="circles-dark"
                [include]="['copy', 'facebook','twitter', 'whatsapp']"
                [showIcon]="true"
                [showText]="false"
              
               
                twitterAccount="rodrigokamada"
                class="pt-5">
              </share-buttons>
            </mat-menu>
          </div>

          <!-- <mat-icon>bookmark_border</mat-icon> -->
        </div>
        <!-- <div class="tools-wrapper">
          
        </div> -->
      </div>
     <!-- Content start from here -->
      <div class="padded-content-wrapper" [class.is-mobile]="isHandsetPortrait">
        <div class="details-content vj">
          <div class="d-flex pt-10 pl-pr-15">
            <label class="lblFilter">Search: </label>
            <div class="col s4 form-group" style="width:30%;margin-right:5px; display: flex;">
              <select id="drpBhani" class="form-control" [(ngModel)]="selectedBaniName" (change)="onBaniSelected($event)">
                <option>--Select--</option>
                <option *ngFor="let baniName of baniNames" [value]="baniName" [selected]="baniName === selectedBaniName">{{ baniName }}</option>
              </select>
              
              <select id="drpSection" class="form-control" [(ngModel)]="selectedSectionName" (change)="onSectionSelected($event)">
                <option>--Select--</option>
                <option *ngFor="let section of sections" [value]="section" [selected]="section === selectedSectionName">{{ section }}</option>
              </select>
              
              <select id="drpSubSection" class="form-control" [(ngModel)]="selectedSubsectionName" (change)="onSubSectionSelected($event)">
                <option>--Select--</option>
                <option *ngFor="let subsection of subsections" [value]="subsection.text" [selected]="subsection.text === selectedSubsectionName">{{ subsection.text }}</option>
              </select>
            </div>
            
           
            
        </div>
        </div>

        <div >

            <div class="baniIntro" style="min-height: 200px; margin-top: 20px;">
              <div [innerHTML]="subsectionContentHTML"></div>
            </div>
            
            <!-- <div
              class="sub-section-content xx"
              ></div> -->

          <!-- <div>
            
              <div class="dictionary-heading"></div>
              <div class="dictionary-detail-wrapper">
                <div class="dictionary-detail-heading">{{ "Meaning" | translate }}</div>
                <div class="dictionary-detail">
                 
                </div>
              </div>
              <div
                
                class="dictionary-detail-wrapper">
                <div class="dictionary-detail-heading">{{ "Grammar" | translate }}</div>
                <div class="dictionary-detail">
                  
                </div>
              </div>
              <div>
              <div class="dictionary-detail-heading">{{ "WordGrammar Footnotes" | translate }}</div>
              <div class="dictionary-detail">
               
              </div>
            </div>
              <div
                
                class="dictionary-detail-wrapper">
                <div class="dictionary-detail-heading">{{ "Etymology" | translate }}</div>
                <div class="dictionary-detail">
                  
                </div>
              </div>
              <div>
                <div class="dictionary-detail-heading">{{ "Footnotes" | translate }}</div>
                <div class="dictionary-detail">
                 
                </div>
              </div>
              <div class="dictionary-detail-wrapper">
              <div class="dictionary-detail-heading">{{ "Etymology Footnotes" | translate }}</div>
             
              </div>
            </div> -->
            <div class="col-lg-12">
              <div class="table-responsive"> 
                  <table class="table baniReviewGrid">
                      <thead>
                          <tr>
                              <th>SR.</th>
                              <th>Word</th>
                              <th>Meaning</th>
                              <th>Grammar</th>
                              <th>Etymology</th>
                              <th>Meaning Footnote</th>
                              <th>Grammar Footnote</th>
                              <th>Etymology Footnote</th>
                          </tr>
                      </thead>
                      <tbody>
                          <tr *ngFor="let result of baniTestResults; let i = index" [ngStyle]="{'background-color': result.color}">
                              <td>{{ i + 1 }}</td>
                              <td>{{ result.WordName }}</td>
                              <td>{{ result.WordMeaning }}</td>
                              <td>{{ result.WordGrammar }}</td>
                              <td>{{ result.WordEtymology }}</td>
                              <td>{{ result.WordMeaningFootnote }}</td>
                              <td>{{ result.WordGrammarFootnote }}</td>
                              <td>{{ result.WordEtymologyFootnote }}</td>
                          </tr>
                      </tbody>
                  </table>
              </div>
          </div>
          
            
                    
          </div>
          <div>
            <ng-container>
              <div>
               <span ></span> 
              </div>
            </ng-container>
          </div>
          <ng-container>
            <div class="sub-details-content cc" [class.is-mobile]="isHandsetPortrait"></div>

            
          </ng-container>
                    
        </div>

        <app-footer [isHandsetPortrait]="isHandsetPortrait"></app-footer>
      </div>
    
  </mat-sidenav-content>
</mat-sidenav-container>
